// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  getapssearch:"https://aps-search.search.windows.net/indexes/aps-search-documents/docs?api-version=2021-04-30-Preview&search=",
  apssuggest:"https://aps-search.search.windows.net/indexes/aps-search-suggester/docs/suggest?api-version=2021-04-30-Preview&$select=metadata_storage_name&$top=5&suggesterName=LS&search=",
  apisearchkey:"TiyWUOmxrxPwvUfMxS3kw385PajbVg3ueToTccVJeYAzSeBF20qo",
  // apiencode:"http://localhost:3000/",
  apiencode:"https://development-api-dev.azurewebsites.net/",
  accesstoken:"AO4cDo8WEIB592q1kXOC",
  googlecaptchasiteKey: '6Lf2nTEfAAAAANDqAPIpbYjdQ2zdOaSLhDSlXC0-',

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
